<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-01-07 
-->
<template>
  <footer class="footer-wrapper">
    <div class="footer-container">
      <!-- Main content area - 3 column layout -->
      <div class="footer-grid">
        <!-- Left - Logo -->
        <div class="footer-logo-section">
          <img src="@/assets/logo@3x.png" alt="Virtronex Logo" class="footer-logo" />
        </div>

        <!-- Middle - Contact Info -->
        <div class="footer-section">
          <h4 class="footer-section-title">Contact Us</h4>
          <div class="footer-links">
            <a href="mailto:info@virtronex.com" class="footer-contact-item">
              <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m2 7 10 7 10-7" />
              </svg>
              <span>info@virtronex.com</span>
            </a>
            <div class="footer-contact-item">
              <svg class="footer-icon footer-icon-pin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <address class="footer-address">
                1312 17TH ST UNIT NUM-2955<br />
                Denver, COLORADO, USA
              </address>
            </div>
          </div>
        </div>

        <!-- Right - Legal -->
        <div class="footer-section">
          <h4 class="footer-section-title">Legal</h4>
          <nav class="footer-nav">
            <router-link to="/disclaimer" class="footer-link">Disclaimer</router-link>
            <router-link to="/privacy" class="footer-link">Privacy Policy</router-link>
            <router-link to="/terms" class="footer-link">Terms & Conditions</router-link>
            <router-link to="/legal-info" class="footer-link">Legal Info</router-link>
          </nav>
        </div>
      </div>

      <!-- Copyright section -->
      <div class="footer-copyright">
        <p class="footer-copyright-text">©2025 All rights reserved.</p>
      </div>

      <!-- Disclaimer section -->
      <div class="footer-disclaimer">
        <p class="footer-disclaimer-text">
          <span class="footer-disclaimer-title">Disclaimer:</span> The information provided on this website is
          for informational purposes only. It should not be considered legal, financial or tax advice. Vircard makes
          no representations as to the accuracy, completeness, suitability or validity of any information on this site
          and will not be liable for any errors, omissions or delays in this information or any losses, injuries or
          damages arising from its display or use. All information is provided on an as-is basis. This website may
          contain links to external websites that are not provided or maintained by or in any way affiliated with
          Vircard. Please note that Vircard does not guarantee the accuracy, relevance, timeliness or completeness of
          any information on these external websites. Links to external websites are provided as a courtesy and do not
          imply Vircard's endorsement of those sites or their content, products or services. Vircard assumes no
          liability for damages resulting from the use of or reliance upon the information provided herein.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerPart",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./footerCss/max.css" scoped></style>
<style src="./footerCss/middle.css" scoped></style>
<style src="./footerCss/flat.css" scoped></style>
<style src="./footerCss/min.css" scoped></style>
<style scoped></style>
